import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { selectIsAuthenticated, useAuthStore } from '@features/auth';

export function RequireAuth() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
